export const checkIfRuleAlreadyExist = (filterRule, dimensionRule) => {
  const isExist = filterRule.some((andRule) => {
    return andRule.some((orRule) => {
      return orRule.field === dimensionRule.field && orRule.value === dimensionRule.value;
    });
  });
  return isExist;
};
